// extracted by mini-css-extract-plugin
export default {"rating":"wD-z","numberOfStars":"xD-z","count":"yD-z","barGraphSpacing":"zD-z","barGraph":"AD-z"};